import React, { useState } from 'react';
import { Button, Grid } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RolesTable from './RolesTable';
import RoleFormModal from './RoleFormModal';

export default function RolesTab() {
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [pagination, setPagination] = useState({ page: 0, size: 10 });

  const handlePaginationChange = (page, size) => {
    setPagination({ page, size });
  };

  return (
    <>
      <Grid container sx={{ justifyContent: 'flex-end', pb: 2 }}>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setCreateModalOpen(true)}>
          {'Add Role'}
        </Button>
      </Grid>

      <RolesTable searchQuery={pagination} handlePaginationChange={handlePaginationChange} />

      <RoleFormModal open={createModalOpen} onClose={() => setCreateModalOpen(false)} mode="create" roleData={null} />
    </>
  );
}
